<section class="contrato">
  <usucampeao-header [backRoute]="rotaAnterior" title="Forma de pagamento"></usucampeao-header>

  <ng-container
    *ngIf="possuiPagamento && (!reurbGratuito || cadastro.averbacaoSelecionada); else templateSelecionarPagamento">
    <ion-text>
      <p class="font-text font-text--medium font-text-bold ion-margin-vertical">
        Indique como gostaria de parcelar o pagamento do serviço:
      </p>
    </ion-text>

    <form [formGroup]="form" class="ion-margin-top">
      <usucampeao-select controlName="totalParcelas" label="Número de parcelas">
        <ion-select-option *ngFor="let opcaoParcelamento of opcoesParcelamento" [value]="opcaoParcelamento.parcela">
          {{ opcaoParcelamento.parcela | parcela }}
        </ion-select-option>

        <span usu-error>{{ gerarMensagemErro('totalParcelas') }}</span>
      </usucampeao-select>

      <usucampeao-select controlName="entradaParcelamentoSelecionado" label="Parcelamento de entrada">
        <ion-select-option *ngFor="let opcaoParcelamento of entradaParcelamentos" [value]="opcaoParcelamento">
          {{ opcaoParcelamento }} {{ opcaoParcelamento > 1 ? 'parcelas' : 'parcela' }}
        </ion-select-option>

        <span usu-error>{{ gerarMensagemErro('entradaParcelamentoSelecionado') }}</span>
      </usucampeao-select>

      <usucampeao-select controlName="diaEntrada" label="Preferência de entrada" *ngIf="!pagamentoAVista">
        <ion-select-option *ngFor="let diaPagamento of diasPagamento" [value]="diaPagamento">
          Dia {{ diaPagamento }}
        </ion-select-option>

        <span usu-error>{{ gerarMensagemErro('diaEntrada') }}</span>
      </usucampeao-select>

      <usucampeao-select controlName="diaVencimento" label="Preferência de vencimento" *ngIf="!pagamentoAVista">
        <ion-select-option *ngFor="let diaPagamento of diasPagamento" [value]="diaPagamento">
          Todo dia {{ diaPagamento }}
        </ion-select-option>

        <span usu-error>{{ gerarMensagemErro('diaVencimento') }}</span>
      </usucampeao-select>

      <div class="contrato__flex contrato__flex--space-between" *ngIf="!possuiSuperSocial; else templateSupersocial">
        <span *ngIf="!cadastro?.cupomDescontoCodigo" class="text-link" (click)="abrirModalAdicionarCupom()">Aplicar
          cupom</span>

        <ng-container *ngIf="cadastro?.cupomDescontoCodigo">
          <p class="font-text">{{cadastro.cupomDescontoCodigo}}</p>
          <span class="text-link text-link--error" (click)="removerCupom()">Remover cupom</span>
        </ng-container>

      </div>

      <ng-template #templateSupersocial>
        <div class="contrato__super-social">
          <ng-container *ngIf="!cadastro.superSocial; else superSocialAtivoTemplate">
            <ion-checkbox mode="md" [(ngModel)]="superSocialSelecionado" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="aoAlterarSuperSocial()">
            </ion-checkbox>
            <ion-text class="ion-margin-start">
              <p class="font-text font-text--medium">Quero participar do programa Super Social</p>
              <span class="text-link" (click)="abrirModalSupersocial()">Saiba mais sobre o programa</span>
            </ion-text>
          </ng-container>

          <ng-template #superSocialAtivoTemplate>
            <ion-icon color="success" name="checkbox"></ion-icon>

            <div>
              <span>Programa Super Social solicitado.</span>

              <span class="text-link text-link--error ion-margin-top" (click)="cancelarProgramaSuperSocial()">
                Cancelar participação no programa
              </span>
            </div>
          </ng-template>
        </div>
      </ng-template>
    </form>

    <usucampeao-cadastro-resumo-pagamento *ngIf="pagamentoSelecionado" [cadastro]="cadastro"
      [totalParcelas]="form?.get('totalParcelas')?.value" [tabelaPreco]="tabelaPreco"
      [superSocialSelecionado]="superSocialSelecionado"
      [entradaParcelasQuantidade]="entradaParcelasQuantidadeSelecionada">
    </usucampeao-cadastro-resumo-pagamento>

    <ion-text>
      <p class="font-text">Os boletos estarão disponíveis após a assinatura do contrato.</p>
    </ion-text>
  </ng-container>

  <ng-template #templateSelecionarPagamento>
    <ion-text>
      <h1 class="title">Serviço gratuito</h1>
      <p class="font-text font-text--medium ion-no-margin">
        Você está adquirindo um serviço gratuito.
      </p>
      <p class="font-text font-text--medium ion-no-margin">
        Por favor, complete a sua inscrição assinando o termo de adesão.
      </p>
      <p class="font-text font-text--medium ion-margin-top">
        Outros serviços complementares opcionais estarão disponíveis para aquisição no futuro mediante pagamento.
      </p>
    </ion-text>

    <div class="contrato__container-valor ion-margin-bottom">
      <ion-text>
        <span class="font-text">Valor total</span>
      </ion-text>
      <ion-text>
        <span class="title">Gratuito</span>
      </ion-text>
    </div>
  </ng-template>

  <usucampeao-footer>
    <ion-button id="forma-pagamento-aceitar-contrato" class="ion-margin-bottom" mode="md" (click)="submit()">
      Confirmar formas de pagamento
    </ion-button>
  </usucampeao-footer>
</section>